import React from 'react';
import { Button, Card, CardBody, LayoutContainer, MessageBlock } from './ui';
import '../styles/infrastructureScreens.css';

function AppErrorFallback({ resetError }) {
  const handleReload = () => {
    if (typeof resetError === 'function') {
      resetError();
    }
    window.location.assign('/');
  };

  return (
    <div className="rg-infra-screen rg-app-error">
      <LayoutContainer size="md" className="rg-app-error__container">
        <Card className="rg-app-error__card rg-elevation-2">
          <CardBody className="rg-app-error__card-body">
            <MessageBlock
              tone="error"
              title="No se pudo mostrar la aplicación"
              actions={
                <Button type="button" variant="primary" onClick={handleReload}>
                  Volver al inicio
                </Button>
              }
            >
              Ocurrió un error inesperado. Recargá la pantalla para continuar. Si el problema sigue, contactá a soporte.
            </MessageBlock>
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
}

export default AppErrorFallback;
